// src/draft/Draft.js
const DRAFT_KEYS = {
  SALES: 'salesDraft',
  SALES_FORM: 'salesFormDraft',
  PRODUCT_RECEIVING: 'productReceivingDraft',
};

export default DRAFT_KEYS;
